module.exports = __webpack_public_path__ + "img/6.d3bc0eb1.jpg";